import React, { Component, Fragment } from 'react'
import i18n from 'i18next'
import * as R from 'ramda'
import { observer } from 'mobx-react'

import SearchLayout from '../Layouts/Search'
import DataTable from '../DataTable'
import Button from '../../UniformComponents/Button'
import Anchor from '../../UniformComponents/Anchor'
import Tooltip from '../../UniformComponents/Tooltip'
import PortfolioStore from './PortfolioStore'
import PortfolioEdit from './PortfolioEdit'
import { PageSwitchTab, tabOptions } from '../PageSwitchTab'
import Badge from '../../UniformComponents/Badge'
import { removeQueryParam, setQueryParam, getQueryParam } from '../../utils/helpers'

const PORTFOLIO_PARAM = 'portfolioId'

@observer
class PortfolioSearch extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
            portfolioId: 0,
            hasMultiDivision: R.pathOr(false, ['userData', 'flags', 'isMultiDivision'], props.store),
        }
        this.portfolioStore = new PortfolioStore(props.store)
        this.setColumns()
    }

    componentDidMount() {
        const { store, location } = this.props
        store.breadcrumps = [
            {
                name: 'portfolio',
                url: '/portfolio',
                title: i18n.t('navmenu.portfolios'),
            },
        ]

        this.portfolioStore.initSearch()

        this.checkQueryParam(location)
    }

    checkQueryParam = (location) => {
        const portfolioId = getQueryParam(location, PORTFOLIO_PARAM)
        if (portfolioId === -1) return
        this.handleOpenModal(portfolioId)
    }

    setColumns = () => {
        const { store } = this.props
        this.columns = [
            {
                name: i18n.t('portfolio'),
                key: 'name',
                cellClass: 'bold',
            },
            {
                name: i18n.t('industry'),
                key: 'industry',
            },
        ]

        if (R.path(['userData', 'flags', 'isMultiDivision'], store)) {
            this.columns.push({
                name: i18n.t('division'),
                key: 'divisionName',
            })
        }

        this.columns.push({
            name: i18n.t('num_events'),
            key: 'numProduct',
            dataTransform: (completed) => (
                <Badge
                    type="grey"
                    cssClass="rounded"
                    label={completed}
                />
            ),
        })

        if (
            store.tokenData.roles.includes(100)
            || store.tokenData.roles.includes(110)
        ) {
            this.columns.push({
                name: '',
                key: 'portfolioId',
                cellClass: 'center overflow',
                dataTransform: (portfolioId) => (
                    <div className="survey-btn-wrapper">
                        <Anchor
                            cssClass="icon-link-btn"
                            onClick={() => {
                                this.handleOpenModal(portfolioId)
                            }}
                        >
                            <Tooltip
                                text={i18n.t('edit_portfolio')}
                                direction="left"
                            />
                            <i className="fa-light fa-edit" />
                        </Anchor>
                    </div>
                ),
            })
        }
    }

    toggleModal = () => {
        this.setState((prevState) => ({
            showModal: !prevState.showModal,
        }))
    }

    handleOpenModal = async (portfolioId) => {
        await this.portfolioStore.initPortfolio(portfolioId, this.handleCloseModal)
        const { location, history } = this.props
        setQueryParam(location, history, PORTFOLIO_PARAM, portfolioId)
        this.setState({ portfolioId })
        this.toggleModal()
    }

    handleCloseModal = () => {
        const { location, history } = this.props
        removeQueryParam(location, history, PORTFOLIO_PARAM)
        this.toggleModal()
        this.portfolioStore.resetFormState()
    }

    goToTab = (tabName) => {
        const { history } = this.props
        if (tabName) history.push(tabName)
    }

    renderFilterOptions = () => {
        const { store } = this.props
        return (
            (
                store.tokenData.roles.includes(100)
                || store.tokenData.roles.includes(110)
            ) && (
                <fieldset className="btn-filter">
                    <Button
                        cssClass="primary large w-100"
                        onClick={() => { this.handleOpenModal(0) }}
                        icon="fa-light fa-circle-plus"
                        label={i18n.t('add_portfolio')}
                    />
                </fieldset>
            )
        )
    }

    renderTablePanel = () => (
        <DataTable
            store={this.portfolioStore}
            inMemory
            dataSet={this.portfolioStore.filteredList || []}
            columns={this.columns}
            sorting
            sortKey="name"
            sortDesc={1}
            cssClass="search-table"
        />
    )

    renderGuide = () => (
        <div dangerouslySetInnerHTML={{
            __html: i18n.t('portfolioSearch.introText'),
        }}
        />
    )

    render() {
        const { store, location, history } = this.props
        const {
            showModal, portfolioId,
            hasMultiDivision,
        } = this.state
        const { industryVENU } = this.portfolioStore

        return (
            <Fragment>
                <PageSwitchTab
                    userRole={store.userData.role}
                    hasMultiDivision={hasMultiDivision}
                    location={location}
                    history={history}
                    tabOptions={tabOptions.manageEvents}
                    industryVENU={industryVENU}
                />
                <SearchLayout
                    pageTitle="Portfolios"
                    renderFilterOptions={this.renderFilterOptions}
                    renderTablePanel={this.renderTablePanel}
                    renderGuide={this.renderGuide}
                    searchStore={this.portfolioStore}
                    hideFilterAccordion
                    showGuideAtInit
                    hasTopNav
                />
                <PortfolioEdit
                    showModal={showModal}
                    handleCloseModal={this.handleCloseModal}
                    store={store}
                    portfolioStore={this.portfolioStore}
                    portfolioId={portfolioId}
                />
            </Fragment>
        )
    }
}

export default PortfolioSearch
